import { createContext } from 'react';

// Context carrying the toast API: { success(msg), error(msg), info(msg) }.
const ToastContext = createContext(null);
export default ToastContext;
